import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { YardReportFormValues } from '@/core/domain/visual-management/yard-report/yard-report.types';
import { Col, Form, FormInstance, Row } from 'antd';
import YardManagementReportDateFilter from './DateFilter';
import CustomersSelectField from '@/components/_common/CustomersSelectField';
import { FloatingFormItem } from '@/components/_common';
import VehicleSelectField from '@/components/_common/VehicleSelectField';
import YardManagementReportOrderBy from './OrderBy';
import StatusSelectField from '@/components/_common/StatusSelectField';
import SituationsSelectField from '@/components/_common/SituationsSelectField';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';

interface Props {
  form: FormInstance<YardReportFormValues>;
}

export default function YardManagementReportForm(props: Props) {
  return (
    <Form form={props.form}>
      <ReportSelectMonthFields
        form={props.form}
        dateFilter={<YardManagementReportDateFilter />}
      />

      <Row gutter={16}>
        <Col span={24} md={16}>
          <FloatingFormItem name="customerIds" label="Clientes">
            <CustomersSelectField mode="multiple" showCpfCnpj allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={16}>
          <FloatingFormItem name="vehicleIds" label="Veículos" noStyle>
            <VehicleSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={16} style={{ marginBottom: 24 }}>
          <YardManagementReportOrderBy />
        </Col>

        <Col span={24} md={16}>
          <FloatingFormItem name="situationIds" label="Situações" noStyle>
            <SituationsSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={16}>
          <FloatingFormItem name="statusIds" label="Status" noStyle>
            <StatusSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={16}>
          <FloatingFormItem name="estimatorIds" label="Orçamentistas" noStyle>
            <EmployeesInfiniteSelectField
              mode="multiple"
              allowClear
              queryFilter={{ estimator: true }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={16}>
          <FloatingFormItem name="technicianIds" label="Funcionários" noStyle>
            <EmployeesInfiniteSelectField
              mode="multiple"
              allowClear
              queryFilter={{ estimator: false }}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
